import { motion } from "framer-motion";
import { Waves, Castle, Wine, Sparkles } from "lucide-react";
import { MaskedLines, Eyebrow, EASE } from "./motion";
import { useLang } from "../i18n";

const ITEMS = [
  { id: "esporao", icon: Wine, img: "/img/vinha.jpg", cls: "md:col-span-2 md:row-span-2 min-h-[420px]" },
  { id: "castle", icon: Castle, img: "/img/castelo.jpg", cls: "md:col-span-2 min-h-[260px]" },
  { id: "beaches", icon: Waves, img: "/img/lago.jpg", cls: "min-h-[260px]" },
  { id: "stars", icon: Sparkles, img: "/img/estrelas.jpg", cls: "min-h-[260px]" },
];

const Tile = ({ it, i }) => {
  const Icon = it.icon;
  const [title, text] = useLang().t.exp[it.id];
  return (
    <motion.div
      data-testid={`bento-item-${it.id}`}
      initial={{ opacity: 0, scale: 0.96, y: 30 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, ease: EASE, delay: i * 0.1 }}
      whileHover={{ y: -6 }}
      className={`group relative overflow-hidden rounded-[28px] ${it.cls} ${it.img ? "bg-[#2B2C27]" : "bg-[#B85D3B]"}`}
    >
      {it.img && (
        <>
          <img src={it.img} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1C1D1A]/85 via-[#1C1D1A]/20 to-transparent" />
        </>
      )}
      <div className="relative h-full p-7 md:p-9 flex flex-col justify-between text-[#F7F5F0]">
        <span className="w-12 h-12 rounded-full border border-[#F7F5F0]/50 flex items-center justify-center backdrop-blur-sm group-hover:bg-[#F7F5F0] group-hover:text-[#1C1D1A] transition-colors">
          <Icon className="w-5 h-5" />
        </span>
        <div>
          <h3 className={`font-display ${i === 0 ? "text-4xl md:text-6xl" : "text-3xl"} leading-none`}>{title}</h3>
          <p className="text-sm text-[#EFE6DA] mt-3 max-w-xs">{text}</p>
        </div>
      </div>
    </motion.div>
  );
};

export const Experiences = () => {
  const e = useLang().t.exp;
  return (
  <section id="experiences" data-testid="experiences-section" className="bg-[#F7F5F0] py-24 md:py-40">
    <div className="max-w-[1440px] mx-auto px-5 md:px-10">
      <div className="grid lg:grid-cols-12 gap-8 mb-14 md:mb-20">
        <div className="lg:col-span-7">
          <Eyebrow>{e.eyebrow}</Eyebrow>
          <MaskedLines lines={[e.l1, <em key="e" className="italic text-[#B85D3B]">{e.l2}</em>]} className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6 text-[#1C1D1A]" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 md:auto-rows-[300px] gap-4 md:gap-5">
        {ITEMS.map((it, i) => <Tile key={it.id} it={it} i={i} />)}
      </div>
    </div>
  </section>
  );
};
